// ✅ redux/states/products/slice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  AllProductsThunk,
  GetSingleProductThunk,
  AddProductThunk,
  UpdateProductThunk,
  DeleteProductThunk,
  AllProductsCategoryThunk,
  AllProductsSubCategoryThunk,
  AllProductGalleryImageThunk,
  GetSingleProductGalleryImageThunk,
  AddProductGalleryImageThunk,
  UpdateProductGalleryImageThunk,
  DeleteGalleryProductThunk,
  GetVarientlistThunk,
  AllSpecialcategoryThunk,
  MarkspecialThunk,
} from "./thunk";

const initialState = {
  products: [],
  category: [],
  varients: [],
  galleryImages: [],
  singleImage: null,
  subcategory: [],
  singleProduct: null,
  loading: false,
  error: null,
  successMessage: null,
  specialcategroy: [],
};

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    clearProductState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AllProductsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllProductsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload?.data || []; // ✅ Adjust according to your API structure
      })
      .addCase(AllProductsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // ✅ Single Product
      .addCase(GetSingleProductThunk.fulfilled, (state, action) => {
        state.singleProduct = action.payload?.data || null;
      })

      // ✅ Add Product
      .addCase(AddProductThunk.fulfilled, (state, action) => {
        state.successMessage = "Product added successfully!";
      })

      // ✅ Update Product
      .addCase(UpdateProductThunk.fulfilled, (state, action) => {
        state.successMessage = "Product updated successfully!";
      })

      // ✅ Delete Product
      .addCase(DeleteProductThunk.fulfilled, (state, action) => {
        state.products = state.products.filter(
          (p) => p.uuid !== action.payload.uuid
        );
        state.successMessage = "Product deleted successfully!";
      })

      // ✅ ALL CATEGORY
      .addCase(AllProductsCategoryThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(AllProductsCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.category = action.payload?.data || [];
      })
      .addCase(AllProductsCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ✅ ALL SUB CATEGORY
      .addCase(AllProductsSubCategoryThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(AllProductsSubCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.subcategory = action.payload?.subcategories || [];
      })
      .addCase(AllProductsSubCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ALL GALLERY IMAGES -------------------- */
      .addCase(AllProductGalleryImageThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(AllProductGalleryImageThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.galleryImages = action.payload?.data || [];
      })
      .addCase(AllProductGalleryImageThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- GET SINGLE IMAGE -------------------- */
      .addCase(GetSingleProductGalleryImageThunk.fulfilled, (state, action) => {
        state.singleImage = action.payload?.data || null;
      })

      /* -------------------- ADD IMAGE -------------------- */
      .addCase(AddProductGalleryImageThunk.fulfilled, (state, action) => {
        state.successMessage = "Gallery image added successfully!";
      })

      /* -------------------- UPDATE IMAGE -------------------- */
      .addCase(UpdateProductGalleryImageThunk.fulfilled, (state, action) => {
        state.successMessage = "Gallery image updated successfully!";
      })

      /* -------------------- DELETE IMAGE -------------------- */
      .addCase(DeleteGalleryProductThunk.fulfilled, (state, action) => {
        state.galleryImages = state.galleryImages.filter(
          (img) => img.uuid !== action.payload.uuid
        );
        if (state.singleImage?.uuid === action.payload.uuid) {
          state.singleImage = null;
        }
        state.successMessage = "Gallery image deleted successfully!";
      })

      /* -------------------- ALL varients list -------------------- */
      .addCase(GetVarientlistThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetVarientlistThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.varients = action.payload?.valiants || [];
      })
      .addCase(GetVarientlistThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ALL special category list -------------------- */
      .addCase(AllSpecialcategoryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllSpecialcategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.specialcategroy = action.payload?.data || []; // ✅ Adjust according to your API structure
      })
      .addCase(AllSpecialcategoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- Mark special category list -------------------- */
      .addCase(MarkspecialThunk.fulfilled, (state) => {
        state.successMessage = "Special category marked successfully!";
      });
  },
});

export const { clearProductState } = productSlice.actions;
export default productSlice.reducer;
